import { ICellRendererParams } from 'ag-grid-community';
import { FC } from 'react';
import { EditIcon, Settings, useUrlParams } from '@aleph/shared-components';
import { RedditLevel } from 'wb-reddit/app/routes/superGrid/utils';
import { useNavigate, useParams } from 'react-router-dom';

const SettingsHeaderRenderer: FC<ICellRendererParams> = () => {
	const navigate = useNavigate();

	const { params } = useUrlParams({ navigate, useParams });

	return (
		<div className="flex items-center justify-center w-full">
			{(params?.level ?? RedditLevel.AD_ACCOUNT) === RedditLevel.AD_ACCOUNT ? (
				<div className="w-[16px]">
					<Settings />
				</div>

			) : (
				<div className="w-[16px]">
					<EditIcon />
				</div>
			)}
		</div>
	);
};

export default SettingsHeaderRenderer;
